// import XmlViewerModal from './XmlViewerModal'
const XmlViewerModal = r => require.ensure([], () => r(require('./XmlViewerModal.vue')), 'xmlviewer-components-chunk')

export { XmlViewerModal }
